import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'hammerjs';
import posthog from 'posthog-js';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// posthog.init(environment.posthog_key, {
//   api_host: environment.posthog_host,
//   capture_pageview: true,
//   debug: true,
//   person_profiles: 'always',
// });

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
